/**
 * @param {Date} date Data a ser formatada para o formato dd/MM/yyyy
 * @returns {string}
 */
export function toDDMMYYYY(date) {
  const yyyy = date.getFullYear();
  const mm = date.getMonth() + 1;
  const dd = date.getDate();

  return `${dd.toString().padStart(2, '0')}/${mm
    .toString()
    .padStart(2, '0')}/${yyyy}`;
}

/**
 * @param {Object} params
 * @param {Number} params.month
 * @param {Number} params.year
 * @param {string} params.locale
 * @returns {String}
 */
export function getFullMonthName({ month, year = 0, locale = 'pt-BR' }) {
  const filterDate = new Date(year || new Date().getFullYear(), month, 1);

  return filterDate.toLocaleString(locale, { month: 'long' });
}